(() => {
  if (window.__jcProductDetailEyeBound) return;
  window.__jcProductDetailEyeBound = true;

  const navigateToDetail = (event) => {
    const trigger = event.target.closest('.jc-product-card__detail-link');
    if (!trigger || !trigger.href) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    window.location.assign(trigger.href);
  };

  // The carousels register drag handlers. Capturing pointer-down routes the detail
  // action before a drag handler can cancel the browser's later click event.
  document.addEventListener('pointerdown', navigateToDetail, true);
  document.addEventListener('click', navigateToDetail, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    navigateToDetail(event);
  }, true);
})();
